module.exports = __webpack_public_path__ + "static/media/bg_waves_fund.b013ddad.svg";